export default "__VITE_ASSET__Kwg5NngW__"